import React, { useState, useMemo } from "react";
import { withTranslation } from "react-i18next";
import DestinationShipmentData from "../DestinationShipmentData/DestinationShipmentData";
import TelemetryVariantSwitch from "../TelemetryVariantSwitch/TelemetryVariantSwitch";
import TelemetryPanel from "../TelemetryPanel/TelemetryPanel";
import {
  getStandaloneBlockingState,
  getTelemetryViewState,
  getTelemetryViewMessage,
} from "../../utils/shipmentTelemetryViewUtils";

function StandAloneShipmentData({
  shipmentParameters,
  telemetryInfo,
  alertsListInfo,
  chartsInfo,
  batteryLevels,
  stepsRef,
}) {
  const { destinationData, numRefClient } = shipmentParameters;
  const [variant, setVariant] = useState("full");

  const blockingView = useMemo(
    () => getStandaloneBlockingState(shipmentParameters, chartsInfo),
    [shipmentParameters, chartsInfo]
  );

  const view = useMemo(
    () => getTelemetryViewState({ chartsInfo, variant }),
    [chartsInfo, variant]
  );

  const viewMessage = useMemo(() => getTelemetryViewMessage(view), [view]);

  const isTelemetryOk = view.state === "ok";

  if (blockingView.type === "message") {
    return (
      <div style={{ height: "20vw", textAlign: "center", paddingTop: "8vw" }}>
        <h4>{blockingView.message}</h4>
      </div>
    );
  }

  if (blockingView.type === "pdf") {
    return (
      <div>
        <object
          style={{ width: "100%", height: "600pt" }}
          type="application/pdf"
          data={"data:application/pdf;base64," + blockingView.pdfBase64}
        />
      </div>
    );
  }

  return (
    <div>
      <DestinationShipmentData destinationData={destinationData} />
      <br />

      <h2>
        Referencia cliente/pedido:{" "}
        <span className="shipment-info">{numRefClient}</span>
      </h2>

      <h2>
        Tipo de datalogger: <span className="shipment-info">StandAlone</span>
      </h2>

      <h2>
        IMEI de caja:{" "}
        <span className="shipment-info">{shipmentParameters.imei}</span>
      </h2>

      <div
        style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}
      >
        <TelemetryVariantSwitch variant={variant} onChange={setVariant} />
      </div>

      {!isTelemetryOk ? (
        <h4 style={{ height: "20vw", textAlign: "center", paddingTop: "8vw" }}>
          {viewMessage}
        </h4>
      ) : (
        <>
          <TelemetryPanel
            shipmentCode={shipmentParameters.shipmentCode}
            telemetryInfo={telemetryInfo}
            alertsListInfo={alertsListInfo}
            chartsInfo={chartsInfo}
            batteryLevels={batteryLevels}
            isStandalone={shipmentParameters.standalone}
            variant={variant}
            stepsRef={stepsRef}
          />
        </>
      )}
    </div>
  );
}

export default withTranslation()(StandAloneShipmentData);
